<template>
    <div class="d-flex fill-width">
        <v-icon
            style="margin-left: -32px"
            class="mr-2 mt-2 align-self-start"
        >
            {{ sendImmediately ? 'mdi-email-outline' : 'mdi-flash-outline' }}
        </v-icon>
        <div class="fill-width">
            <div class="body-2">
                <PlannedEmailText
                    :email-automation="item"
                    :send-now-enabled="canSendNow"
                    @select="isActive = !isActive"
                    @send-now="$emit('send-now')"
                />
            </div>
            <v-expand-transition>
                <div v-show="isActive">
                    <div style="max-height: 500px" class="overflow-y-auto grey-content fill-width my-1">
                        <div v-html="formattedContent" /> <!-- INPUT CLEANED WHEN SAVING -->
                    </div>
                    <div v-if="item.attachments && item.attachments.length" class="mt-2">
                        <AttachmentsList
                            :files="item.attachments"
                            :can-delete="false"
                            @download="downloadAttachment($event)"
                        />
                    </div>
                </div>
            </v-expand-transition>
            <Footer
                :created_at="item.created_at"
                :can-delete="canEdit"
                :can-edit="canEdit"
                @delete="$emit('delete')"
                @edit="$emit('edit')"
            >
                <template v-slot:edit>
                    <v-tooltip v-if="canEdit" :disabled="!templateText" bottom>
                        <template v-slot:activator="{ on }">
                            <div
                                class="caption n3--text text-decoration-underline cursor-pointer mx-1"
                                v-on="on"
                                @click="$emit('edit')"
                            >
                                {{ $t("Edit") }}
                            </div>
                        </template>
                        <span>{{ templateText }}</span>
                    </v-tooltip>
                </template>
            </Footer>
        </div>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import { ref, computed } from "@vue/composition-api";
import Footer from '../Footer'
import AttachmentsList from "../../../../components/AttachmentsList";
import { downloadFile } from "@/helpers/helpers";
import TaskAutomationLogModule from "@/modules/emailing/taskAutomationLog";
import EmailAutomationModule from "@/store/modules/email_automation"
import PlannedEmailText from "@/components/Emailing/PlannedEmailText/Index"

export default {
    name: "AutomationRow",
    components: {
        Footer,
        AttachmentsList,
        PlannedEmailText
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true
        },
        placeholderData: {
            type: Object,
            default: null
        },
        emailingEnabled: {
            type: Boolean,
            required: true
        },
        canSendNow: {
            type: Boolean,
            required: true
        },
        isFullPage: {
            type: Boolean,
            required: true
        },
        clientId: {
            type: Number,
            default: null
        },
        companyId: {
            type: Number,
            required: true
        }
    },
    setup (props) {
        const isActive = ref(false)
        const { emailAutomationTemplates } = EmailAutomationModule()

        const getTemplateRow = () => {
            const template = emailAutomationTemplates.value.find(x => x.id === props.item.content_template_id)
            if (!template) {
                return
            }

            return template.rows.find(x => x.locale_code === props.item.locale_code)
        }

        const formattedContent = computed(() => {
            let content = props.item.content

            if (props.item.content_template_id) {
                const templateRow = getTemplateRow()
                if (templateRow) {
                    content = templateRow.content
                }
            }

            if (!content) {
                return ""
            }

            return content
        })

        const downloadAttachment = (file) => {
            downloadFile('email_task/attachment', file)
        }

        const sendImmediately = computed(() => !props.item.trigger || props.item.trigger === "")

        const templateText = computed(() => {
            if (!props.item.content_template_id) {
                return
            }

            const templateRow = getTemplateRow()
            if (!templateRow) {
                return
            }

            return `${$t('Template')}: ${templateRow.subject} (${props.item.locale_code})`
        })

        return {
            isActive,
            downloadAttachment,
            formattedContent,
            sendImmediately,
            templateText,
            TaskAutomationLogModule,
        }
    }
}
</script>

<style scoped>

</style>